import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useUserGroup } from './userGroup.context';

/**
 * Composant de bouton de sauvegarde avec validation
 *
 * Ce composant :
 * - Affiche un bouton de sauvegarde
 * - Valide les champs obligatoires avant activation
 * - Affiche les messages d'erreur de validation
 * - Utilise le contexte de groupe d'utilisateurs
 *
 * Logique métier :
 * - Validation des champs obligatoires (login, rôle)
 * - Désactivation du bouton si validation échoue
 * - Affichage des messages d'erreur sous le bouton
 *
 * @returns Composant React du bouton de sauvegarde
 */
export const SaveButton: React.FC = () => {
  const { userGroup, save } = useUserGroup();

  const cannotSaveMessages = [];
  if (isEmpty(userGroup.login)) {
    cannotSaveMessages.push(`Renseigner l'identifiant`);
  }
  if (isEmpty(userGroup.role)) {
    cannotSaveMessages.push(`Renseigner le rôle`);
  }

  return (
    <Box display="flex" flexDirection="column">
      <Button
        color="secondary"
        variant="contained"
        disabled={cannotSaveMessages.length > 0}
        onClick={save}
      >
        Enregistrer
      </Button>
      {cannotSaveMessages.length > 0 && (
        <ul>
          {cannotSaveMessages.map((message, index) => (
            <li key={index}>
              <Typography color={'error'}>{message}</Typography>
            </li>
          ))}
        </ul>
      )}
    </Box>
  );
};
